import {PennylaneRecapModal, PennylaneRecapModalProvider} from "@mytour/company-settings";
import {HasRole, useIsMultiUser} from "@mytour/platform";
import {isMobile} from "react-device-detect";
import {Outlet} from "react-router";
import {ErrorBoundaryWrapper} from "../routes/ErrorBoundaryRoute";
import {ManagerHeader} from "./roles/multi-manager/ManagerHeader";
import {ManagerModals} from "./roles/multi-manager/ManagerModals";
import {WorkerHeader} from "./roles/multi-worker/WorkerHeader";
import {SoloHeader} from "./roles/solo/SoloHeader";
import {SoloModals} from "./roles/solo/SoloModals";

export function RootLayout() {
  return (
    /**
     * Modale Récap Pennylane globale (#651) : montée ICI, jamais dans le
     * cascade `AppModals` — celui-ci retourne tôt sur CGU/paiement/onboarding
     * non terminés, et une modal montée après ce point ne s'afficherait
     * jamais tant que ces états bloquants sont actifs, même une fois ouverte
     * via `usePennylaneRecapModal` (écran de choix Facturation, nudge #650).
     * Montée en sibling, elle ne dépend d'aucun de ces early-returns.
     */
    <PennylaneRecapModalProvider>
      <HasRole role="worker">
        <ErrorBoundaryWrapper>
          <WorkerHeader />
        </ErrorBoundaryWrapper>
      </HasRole>
      <HasRole role="manager">
        <ManagerLayout />
      </HasRole>
      <div className="page-container">
        <ErrorBoundaryWrapper>
          <Outlet />
        </ErrorBoundaryWrapper>
      </div>
      <PennylaneRecapModal />
    </PennylaneRecapModalProvider>
  );
}

function ManagerLayout() {
  const isMultiUserMode = useIsMultiUser();

  if (isMultiUserMode && !isMobile) {
    return (
      <>
        <ErrorBoundaryWrapper>
          <ManagerHeader />
        </ErrorBoundaryWrapper>
        <ErrorBoundaryWrapper>
          <ManagerModals />
        </ErrorBoundaryWrapper>
      </>
    );
  }
  return (
    <>
      <ErrorBoundaryWrapper>
        <SoloHeader />
      </ErrorBoundaryWrapper>
      <ErrorBoundaryWrapper>
        <SoloModals />
      </ErrorBoundaryWrapper>
    </>
  );
}
